module.exports = __webpack_public_path__ + "media/images/emblems/Cresuz-coat_of_arms-2a0410e4dcb5c6407bc8ba6b9bd51026.svg";